define('modules/editor/views/elements_tree',['require','exports','module','base/layout','./elements_tree_children','../models/editorstate','ldsh!../templates/elements_tree'],function(require, exports, module) {
  'use strict';

  var Layout = require('base/layout'),
    ElementsTreeChildren = require('./elements_tree_children'),
    EditorState = require('../models/editorstate');

  module.exports = Layout.extend({

    template: require('ldsh!../templates/elements_tree'),

    regions: {
      'tree': '.js-tree-children'
    },

    initialize: function(options) {
      this._onChangeTreeDebounced = _.debounce(this._onChangeTree, 100);
      this.listenTo(options, 'element:added element:added section:added element:removed', this._onChangeTreeDebounced, this);
      this.listenTo(EditorState, 'rerenderTree formChanged variant:changed idChanged', this._onChangeTreeDebounced, this);
    },

    onShow: function () {
      this._collectionView = new ElementsTreeChildren({ elements: this.options.sections });
      this.regions.tree.show(this._collectionView);
    },

    _onChangeTree: function () {
      this._collectionView.onChangeTree();
    },

    onRender: function(){
      this.$el.i18n();
    }

  });
});

